<template>
  <div>
    <h3 class="title mb-3 green--text">Contrato</h3>
    <p>
      <strong>Número do Contrato: </strong
      >{{ beneficiarioPinss ? beneficiarioPinss.contrato : "" }}
    </p>
    <p>
      <strong>Data de Contratação: </strong
      >{{
        beneficiarioPinss
          ? beneficiarioPinss.contratoInicioVigencia
          : "" | formatDate
      }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
